import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import BaseFeature from '../../foundation/base/base';

class Header extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.log('Header Feature Init');

		this.classes = {
			navIsOpen: 'is-open'
		};

		this.initDomCache();
		this.init();
	}

	init() {
		this.dom.navController.addEventListener('click', () => {
			this.setNavIsOpen();
		});
	}

	navIsOpen() {
		return this.dom.navController.checked;
	}

	setNavIsOpen() {
		const isNavOpen = this.navIsOpen();

		// Toggle the class based on our test
		this.el.classList.toggle(this.classes.navIsOpen, isNavOpen);

		// Lock scrolling on body
		if (isNavOpen) {
			disableBodyScroll(this.dom.navPanel, {
				reserveScrollBarGap: true
			});
		} else {
			clearAllBodyScrollLocks();
		}
	}
}

export default Header;
